import ErrorBase, { ErrorSeverity } from './ErrorBase';
export default class StorageNotAvailableException extends ErrorBase {
    constructor(loggingDetails = {}) {
        super('The storage is not available', loggingDetails, ErrorSeverity.INFO);
        this.name = 'StorageNotAvailableException';
    }
}
